import React from "react";

// Parametric guilloche / spirograph rosette (banknote-style security ornament).
function rosette(cx, cy, a, b, f, phase = 0, step = 0.015) {
  let pts = [];
  for (let t = 0; t <= Math.PI * 2 + step; t += step) {
    const x = cx + a * Math.cos(t) + b * Math.cos(f * t + phase);
    const y = cy + a * Math.sin(t) - b * Math.sin(f * t + phase);
    pts.push(`${x.toFixed(2)},${y.toFixed(2)}`);
  }
  return "M" + pts.join(" L") + "Z";
}

export default function Guilloche({ size = 300, opacity = 0.55, className = "", style = {} }) {
  const c = size / 2;
  const s = size / 300; // scale factor
  // one clean 8-petal rosette drawn at concentric scales -> banknote guilloche rings
  const scales = [1, 0.8, 0.6, 0.42, 0.26];
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={className}
         style={{ opacity, ...style }} aria-hidden="true">
      {scales.map((sc, i) => (
        <path key={i} d={rosette(c, c, 92 * s * sc, 26 * s * sc, 9)}
              fill="none" stroke="var(--gold)" strokeWidth={0.55} />
      ))}
      <circle cx={c} cy={c} r={14 * s} fill="none" stroke="var(--gold)" strokeWidth={0.6} />
      <circle cx={c} cy={c} r={7 * s} fill="none" stroke="var(--gold)" strokeWidth={0.5} />
    </svg>
  );
}

// Double wavy security rule used under headings.
export function WavyRule({ className = "", color = "var(--paper-line)" }) {
  const wave = (y) => {
    let d = `M0 ${y}`;
    for (let x = 0; x <= 1200; x += 20) {
      d += ` Q ${x + 5} ${y - 3} ${x + 10} ${y} T ${x + 20} ${y}`;
    }
    return d;
  };
  return (
    <svg className={className} width="100%" height="14" viewBox="0 0 1200 14" preserveAspectRatio="none" aria-hidden="true">
      <path d={wave(4)} fill="none" stroke={color} strokeWidth="1" />
      <path d={wave(10)} fill="none" stroke={color} strokeWidth="1" />
    </svg>
  );
}
